<script setup>
import AutocompleteFilter from '@/components/widgets/AutocompleteFilter.vue';
import { ref, inject, onMounted } from 'vue';
const backendApi = inject('backendApi');

const emit = defineEmits(['update']);
defineProps({
    hideLabel: {
        type: Boolean,
        default: false
    },
    itemTitle: {
        default: 'name'
    },
    itemValue: {
        default: 'id'
    }
});

const selected = ref(null);
const searchQuery = ref('');
const loading = ref(true);
const branch = ref([]);
const showRetryButton = ref(false);

const getBranch = () => {
    cleanData();

    backendApi()
        .branch()
        .index({
            pattern: searchQuery.value,
            active: true
        })
        .then(success, fail)
        .finally(() => (loading.value = false));

    function success(response) {
        branch.value = response.data;
    }

    function fail() {
        showRetryButton.value = true;
    }
};

const cleanData = () => {
    branch.value = [];
    loading.value = true;
    showRetryButton.value = false;
};

onMounted(() => getBranch());
</script>

<template>
    <AutocompleteFilter
        v-model="selected"
        v-model:search="searchQuery"
        :item-title="itemTitle"
        :item-value="itemValue"
        :items="branch"
        :label="hideLabel ? '' : $t('Branch')"
        :loading="loading"
        :show-retry-button="showRetryButton"
        @update="emit('update', selected)"
        @preparing-search="cleanData"
        @search="getBranch"
        @retry="getBranch"
    >
        <template v-slot:default="{ props, item }">
            <v-list-item v-bind="props" :title="`${item.raw.name}`">
            </v-list-item>
        </template>

        <template v-if="$slots.prepend" v-slot:prepend>
            <slot name="prepend"></slot>
        </template>
    </AutocompleteFilter>
</template>
